import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  // Tracks the number of ongoing requests
  private _requestsInFlight = new BehaviorSubject<number>(0);
  requestsInFlight$ = this._requestsInFlight.asObservable();

  // Centralized ignore list
  private ignoredUrls: string[] = [
    'authenticate/counts',
    'data/GetPropertySourceQueue',
    'layout/moduleInformation',
    'ApiCommunication/ActivityList'
    // Add more as needed
  ];

  addRequest(url: string): void {
    const shouldIgnore = this.shouldIgnore(url);
    if (!shouldIgnore) {
      this._requestsInFlight.next(this._requestsInFlight.value + 1);
    }
  }

  removeRequest(url: string): void {
    const shouldIgnore = this.shouldIgnore(url);
    if (!shouldIgnore) {
      const current = this._requestsInFlight.value;
      if (current > 0) {
        this._requestsInFlight.next(current - 1);
      }
    }
  }

  private shouldIgnore(url: string): boolean {
    // Use the relative URL for checking against the ignored list
    return this.ignoredUrls.some((ignore) => url.includes(ignore));
  }
}
